var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.excluded)?_c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.tree}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }